const t = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.7241%200L6%2040H11.5172L14.046%2030.5747H26.6897L29.2184%2040H34.7356L23.0115%200H17.7241ZM15.4253%2025.2874L20.2529%207.35632L25.0805%2025.2874H15.4253Z'%20fill='%23A6CE39'/%3e%3c/svg%3e";
export {
  t as default
};
